<template>
  <div>
    <el-dialog
      v-if="!isMobile"
      append-to-body
      title="修改评论"
      :visible="show"
      :close-on-click-modal="false"
      width="400px"
      @close="closeDialog"
    >
      <div class="content">
        <el-input
          v-model="content"
          type="textarea"
          rows="4"
          placeholder="请输入评论内容"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取 消</el-button>
        <el-button
          type="primary"
          :loading="doSubmitLoading"
          size="small"
          @click="doSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <van-dialog
      v-if="isMobile"
      :value="show"
      title="修改评论"
      show-cancel-button
      :beforeClose="doSubmit"
      @click-overlay="closeDialog"
      @click-close-icon="closeDialog"
    >
      <div class="mobile-commit">
        <el-input
          v-model="content"
          type="textarea"
          placeholder="请输入评论内容"
          rows="4"
          autofocus
        ></el-input>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog ,Toast } from "vant";
Vue.use(Dialog);
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      content: "",
      doSubmitLoading: false,
    };
  },

  computed: {
    commentList() {
      return this.$store.state.preview.commentList;
    },
  },

  created() {
    this.content = this.row.content;
  },
  methods: {
    closeDialog() {
      this.$emit("update:show", false);
    },
    async doSubmit(e, done = Function) {
      if (e == "cancel") {
        done();
        this.closeDialog();
        return;
      }
      if (this.content.trim().length == 0) {
        this.isMobile ? Toast("评论内容不能为空") :this.$message.error("评论内容不能为空");
        done(false);
        return;
      }
      await this.api.comment.edit({ id: this.row.id, content: this.content });
      this.isMobile ? Toast({message:"修改成功",position:"bottom"}) :this.$message.success("修改成功");
      this.commentList.forEach((item) => {
        if (item.id == this.row.id) {
          item.content = this.content;
        }
      });
      this.$store.commit("preview/UPDATE_COMMENT_LIST", this.commentList);
      done();
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.mobile-commit {
  padding: 20px;
}
</style>
